export default __webpack_public_path__ + "static/media/arrow-down-black.2b61add5.svg";